import { Observable } from "rxjs";
import { BRAND_ORDER_TERMS_UPDATE, BRAND_ORDER_TERMS_UPDATE_COMPLETE } from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const updateOrderTermsEpic = (action$, store) => {
    return action$
        .ofType(BRAND_ORDER_TERMS_UPDATE)
        .map((action) => {
            return action.payload;
        })
        .concatMap((terms) => {
            const data = terms ? terms : "undefined"; // weird legacy api hack
            return ajax({
                method: "POST",
                body: {
                    terms,
                },
                url: `${siteConfig.api}/brand/orders/orderlegalterms`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: "Error saving order terms" })),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_ORDER_TERMS_UPDATE_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_ORDER_TERMS_UPDATE_COMPLETE,
                            },
                            snackbarAdd({ message: "Order terms updated" }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving order terms");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit order terms");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_ORDER_TERMS_UPDATE_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};
